import { Reveal, SectionHeading } from "./anim";

const STEPS = [
  {
    title: "Schedule a consultation",
    body: "A focused conversation about your goals and the opportunity in front of you. No pressure, no obligation.",
  },
  {
    title: "Discovery",
    body: "We learn your position, your resources, and what success actually looks like for you.",
  },
  {
    title: "Analysis",
    body: "Opportunity analysis and risk assessment, tailored to your situation and the decision at hand.",
  },
  {
    title: "Strategy and guidance",
    body: "A clear strategic plan, actionable next steps, and ongoing guidance as you execute.",
  },
];

export default function HowItWorks({ onBook }) {
  return (
    <section id="process" data-testid="process-section" className="mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-36">
      <div className="grid gap-14 lg:grid-cols-[1fr_1.4fr] lg:gap-24">
        <div>
          <SectionHeading
            overline="How It Works"
            title="From first conversation to strategic plan."
            copy="A straightforward process designed to give you clarity quickly. Most clients gain strategic direction from the very first consultation."
          />
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-md text-xs font-light leading-relaxed text-[#71717A]">
              Client stories and results are published only with written permission, as engagements complete.
              We never invent reviews.
            </p>
          </Reveal>
          <Reveal delay={0.28}>
            <button data-testid="process-book-cta" onClick={onBook} className="btn-gold mt-8">
              Schedule a Consultation
            </button>
          </Reveal>
        </div>

        <div className="grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08} className="h-full">
              <div data-testid={`process-step-${i + 1}`} className="group h-full bg-[#08080A] p-8 transition-colors duration-500 hover:bg-[#0F0F12]">
                <span className="text-outline-gold text-5xl font-semibold leading-none" aria-hidden="true">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="mt-4 text-lg font-light tracking-tight text-[#F9F8F6]">{s.title}</h3>
                <p className="mt-2 text-sm font-light leading-relaxed text-[#A1A1AA]">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
